import "./App.css";
import { Route, Routes, HashRouter, Navigate } from "react-router-dom";
import RootLayout from "./layout/RootLayout";
import {
  Dashboard,
  StudentManagement,
  CategoryManagement,
  CoursesManagement,
  ChallengesManagement,
  FeedManagement,
  LivestreamManagement,
  Notification,
  PaymentMangement,
  PodcastManagement,
  SubAdmin,
  SendEmail,
  ResetPassword,
  LoginSuccess,
  ForgetPassword,
  Login,
  StaticContentManagement,
  ChangePassword,
  Topics,
} from "./pages";
import AddPodcast from "./components/podcast/add/AddPodcast";
import AddChallenges from "./components/challenges/AddChallenges";
import AddLiveStream from "./components/livestream/AddLiveStream";
import AddSubAdmin from "./components/subAdmin/AddSubAdmin";
import CustomeToastContainer from "./components/CustomeToastContainer";
import Logout from "./pages/Logout";
import ProtectedRoute from "./components/ProtectedRoute";
import { getToken } from "./utils/getToken";
import StudentDetail from "./pages/StudentDetail";
import CourseContent from "./components/courseManagement/addCourse/CourseContent";
import CourseDetail from "./components/courseManagement/viewCourse/CoursesDetails";
import CourseDetails from "./components/studentManagement/activityDetails/CourseDetails";
import AddCourses from "./components/courseManagement/addCourse/AddCourses";
import EditCourseDetail from "./components/courseManagement/editCourse/EditCourseDetail";
import EditCourseContent from "./components/courseManagement/editCourse/EditCourseContent";
import AddLecture from "./components/courseManagement/addCourse/AddLecture";
import EditLecture from "./components/courseManagement/editCourse/EditLecture";
import PodcastDetail from "./components/podcast/view/PodcastDetail";
import AddEpisode from "./components/podcast/view/AddEpisode";
import EpisodeDetail from "./components/podcast/view/EpisodeDetail";
import EditEpisode from "./components/podcast/edit/EditEpisode";
import EditLivestream from "./components/livestream/upcoming/EditLivestream";
import UpcomingDetails from "./components/challenges/upcoming/UpcomingDetails";
import EditUpcomingChallanges from "./components/challenges/upcoming/EditUpcomingChallanges";
import WinnerList from "./components/challenges/completed/WinnerList";
import WinnerListDetail from "./components/challenges/completed/WinnerListDetail";
import AddWinnerList from "./components/challenges/leaderboard/AddWinnerList";
import InputDragDrop from "./components/InputDragDrop";
import EditStaticManagement from "./pages/EditStaticManagement";
import EditSubAdmin from "./pages/EditSubAdmin";
import ViewSubAdmin from "./pages/ViewSubAdmin";
import Profile from "./pages/Profile";
import CourseRating from "./pages/CourseRating";
import LiveStreamReview from "./components/livestream/completed/LiveStreamReview";
import ChallengeDetails from "./components/challenges/ongoing/ChallengeDetails";
import SubmissonDetails from "./components/challenges/ongoing/SubmissonDetails";
import ListSubmission from "./components/challenges/ongoing/ListSubmission";
import AddRankPoint from "./components/challenges/ongoing/AddRankPoint";
import LiveSubmissionCompleted from "./components/challenges/completed/LiveSubmissionCompleted";
import ViewPrizeDetail from "./components/challenges/leaderboard/ViewPrizeDetail";
import AddPrize from "./components/challenges/leaderboard/AddPrize";
import EditPrize from "./components/challenges/leaderboard/EditPrize";
import ViewPrize from "./components/challenges/leaderboard/ViewPrize";
import EditDetailEpisode from "./components/podcast/view/EditEpisode";
import EpisodeList from "./components/podcast/view/EpisodeList";
import PoadcastRating from "./components/podcast/PoadcastRating";
import StudentDetails from "./components/studentManagement/StudentDetails";
import EditNotification from "./components/notification/EditNotification";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
function App() {
  const isAuthenticated = getToken("adminLogin");
  return (
    <>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate to={isAuthenticated ? "/dashboard" : "/login"} />
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/loginSuccess" element={<LoginSuccess />} />
          <Route path="/sendEmail" element={<SendEmail />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<RootLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="profile" element={<Profile />} />
              <Route path="student" element={<StudentManagement />} />
              <Route path="category" element={<CategoryManagement />} />
              <Route path="courses" element={<CoursesManagement />} />
              <Route path="courses/courseAdd" element={<AddCourses />} />
              <Route path="courses/addLecture" element={<AddLecture />} />
              <Route path="courses/courseEdit" element={<EditCourseDetail />} />
              <Route
                path="courses/editCourseContent"
                element={<EditCourseContent />}
              />
              <Route path="courses/editEpisode" element={<EditEpisode />} />
              <Route path="courses/editLecture" element={<EditLecture />} />
              <Route path="courses/courseContent" element={<CourseContent />} />
              <Route path="courses/courseDetails" element={<CourseDetail />} />
              <Route path="courses/courseRating" element={<CourseRating />} />
              <Route path="challenges" element={<ChallengesManagement />} />
              <Route
                path="challenges/challengeAdd"
                element={<AddChallenges />}
              />
              <Route
                path="challenges/upComingDetails"
                element={<UpcomingDetails />}
              />
              <Route
                path="challenges/editUpcoming"
                element={<EditUpcomingChallanges />}
              />
              <Route
                path="challenges/winnerListCompleted"
                element={<WinnerList />}
              />
              <Route
                path="challenges/winnerListDetails"
                element={<WinnerListDetail />}
              />
              <Route
                path="challenges/leaderboardAddWinnerList"
                element={<AddWinnerList />}
              />
              <Route
                path="challenges/challengesDetails"
                element={<ChallengeDetails />}
              />
              <Route
                path="challenges/submissionDetail"
                element={<SubmissonDetails />}
              />
              <Route
                path="challenges/listSubmission"
                element={<ListSubmission />}
              />
              <Route
                path="challenges/rankPointAdd"
                element={<AddRankPoint />}
              />
              <Route
                path="challenges/liveSubmissionCompleted/:type"
                element={<LiveSubmissionCompleted />}
              />
              <Route
                path="challenges/viewPrizeDetails"
                element={<ViewPrizeDetail />}
              />
              <Route path="challenges/addPrize" element={<AddPrize />} />
              <Route path="challenges/editPrize" element={<EditPrize />} />
              <Route path="challenges/viewPrize" element={<ViewPrize />} />
              <Route path="feed" element={<FeedManagement />} />
              <Route path="livestream" element={<LivestreamManagement />} />
              <Route
                path="livestream/livestreamAdd"
                element={<AddLiveStream />}
              />
              <Route
                path="livestream/editUpcomingLiveStream"
                element={<EditLivestream />}
              />
              <Route path="livestream/review" element={<LiveStreamReview />} />

              <Route path="notification" element={<Notification />} />
              <Route path="notification/edit" element={<EditNotification />} />
              <Route path="payment" element={<PaymentMangement />} />
              <Route path="podcast" element={<PodcastManagement />} />
              <Route path="podcast/addPodCast" element={<AddPodcast />} />
              <Route path="podcast/podcastDetail" element={<PodcastDetail />} />
              <Route path="podcast/rating" element={<PoadcastRating />} />
              <Route path="podcast/EpisodeList" element={<EpisodeList />} />
              <Route path="podcast/addEpisode" element={<AddEpisode />} />
              <Route
                path="podcast/episodeDetails"
                element={<EpisodeDetail />}
              />
              <Route path="podcast/editEpisode" element={<EditEpisode />} />
              <Route
                path="podcast/editDetailEpisode"
                element={<EditDetailEpisode />}
              />
              <Route path="subadmin" element={<SubAdmin />} />
              <Route path="subadmin/editSubAdmin" element={<EditSubAdmin />} />
              <Route path="subadmin/viewAubAdmin" element={<ViewSubAdmin />} />
              <Route path="subadmin/AddSubAdmin" element={<AddSubAdmin />} />
              <Route
                path="staticContent"
                element={<StaticContentManagement />}
              />
              <Route
                path="editStaticContent"
                element={<EditStaticManagement />}
              />
              <Route path="logout" element={<Logout />} />
              <Route path="changePassword" element={<ChangePassword />} />
              <Route
                path="student/studentDetails"
                element={<StudentDetails />}
              />
              <Route path="topicDetails" element={<Topics />} />
            </Route>
            <Route path="inputDrag" element={<InputDragDrop />} />
          </Route>
            <Route path="termsCondition" element={<TermsAndCondition />} />
            <Route path="privacyPolicy" element={<PrivacyPolicy />} />
        </Routes>
      </HashRouter>
      <CustomeToastContainer />
    </>
  );
}

export default App;
